<template>
  <div class="about-detail">
    <div class="left">
      <div class="p1"  :class="globalTransition">
        <p>{{$t('aboutPage.p2.p1')}}</p>
      </div>
      <div class="p2"  :class="globalTransition">
        <p class="title">{{$t('aboutPage.p2.p2')}}</p>
        <p>{{$t('aboutPage.p2.p3')}}</p>
      </div>
      <img :src="aboutImg1Url" alt="DIMER" class="aboutImg1">
      <div class="p3"  :class="globalTransition">
        <p>{{$t('aboutPage.p2.p4')}}</p>
      </div>
      <div class="p4"  :class="globalTransition">
        <p>{{$t('aboutPage.p2.p5')}}</p>
        <p>{{$t('aboutPage.p2.p6')}}</p>
        <p>{{$t('aboutPage.p2.p7')}}</p>
        <p>{{$t('aboutPage.p2.p8')}}</p>
      </div>
    </div>
    <div class="right color-block1">
      <div class="title"  :class="globalTransition">
        <h2>{{$t('about.latestNews')}}</h2>
      </div>
      <div class="content"  :class="globalTransition">
        <div v-for="event in newwList" :key="event.id" class="news-item">
          <p class="p1">{{event.id}}.</p>
          <p class="p2">{{$t('aboutPage.p2.news.state')}}</p>
          <p class="p3">{{$t('aboutPage.p2.news.'+event.title)}}</p>
          <p class="p4" v-if="language==='zh'">{{(new Date(event.date)).toLocaleDateString()}}</p>
          <p class="p4" v-else>{{(new Date(event.date)).toDateString()}}</p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aboutImg1 from '@/assets/aboutImg1.jpg';

export default {
  name: 'aboutDetail',
  data() {
    return {
      aboutImg1Url: aboutImg1,
      newwList: [
        { id: '01', title: 'news1', date: '2019-06-03' },
        { id: '02', title: 'news2', date: '2019-05-28' },
        { id: '03', title: 'news3', date: '2019-03-12' },
        { id: '04', title: 'news4', date: '2019-02-05' },
      ],
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
};
</script>

<style lang="scss" scoped>
  .about-detail {
    padding-top: 6rem;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    .left {
      width: 65%;
      display: flex;
      flex-direction: column;
      font-size: 1.4rem;
      .p1 {
        color: #369ff6;
      }
      .p1, .p2 {
        .title {
          font-size: 2rem;
          line-height: 3rem;
          font-weight: 900!important;
        }
        padding: 10px 12%;
        line-height: 2rem;
      }
      .aboutImg1 {
        padding-top: 50px;
        width: 100%;
      }
      .p3 {
        padding: 50px 18% 10px 20%;
        line-height: 2rem;
      }
      .p4 {
        padding: 10px 18% 80px 20%;
        line-height: 2rem;
      }
    }
    .right {
      width: 35%;
      padding-left: 5%;
      .title{
        padding-left: 20px;
      }
    }
  }

  .news-item {
    padding: 20px;
    cursor: pointer;
    font-size: 1.4rem;
    .p1 {
      color: #369ff6;
      font-weight: bold;
    }
    .p3 {
      font-weight: bold;
      line-height: 0px;
    }
    .p4 {
      color: #666;
      line-height: 12px;
      font-size: 1rem;
    }
  }

  .news-item:hover{
    background-color: #409EFF;
    transition: 0.3s;
    color: #fff;
    .p1{
      color: #fff;
    }
    .p4{
      color: #fff;
    }
  }
  .color-block1{
    background-size: 200px;
    background-position-x: 100%;
    background-position-y: 85%;
    background-repeat: no-repeat;
    background-image:url("../../assets/color-block.png");
  }
</style>



// WEBPACK FOOTER //
// src/views/aboutPage/detail.vue